import React from 'react';

import { styled } from '@mui/material/styles';

import {
  Box,
  Typography,
  TypographyVariant
} from '@mui/material';



interface IContainerBoxProps {
  center?: boolean;
}

const ContainerBox = styled(Box, {
  shouldForwardProp: prop =>
    prop !== 'center'
})<IContainerBoxProps>(({theme, center}) => ({
  marginBottom: theme.spacing(3),
  display: 'flex',
  justifyContent: center ? 'center' : 'space-between',
  alignItems: 'center',
  textAlign: center ? 'center' : undefined
}));



export interface IProps {
  center?: boolean;
  titleTypographyVariant?: TypographyVariant;
  title?: string;
  children?: React.ReactNode;
}

export const FC: React.FC<IProps> = props => {
  return (
    <ContainerBox center={props.center}>
      {props.title && (
        <Typography variant={props.titleTypographyVariant}>
          {props.title}
        </Typography>
      )}

      {props.children}
    </ContainerBox>
  );
};
